"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemas = exports.Instruction = exports.ChangeAdministratorInstruction = exports.CreateConfigInstruction = exports.TransferMultisigInstruction = exports.serializeSignDevestingInstruction = exports.CreateMultisigInstruction = exports.ChangeVestingTypeScheduleInstruction = exports.WithdrawExcessiveFromPoolInstruction = exports.WithdrawFromVestingInstruction = exports.CreateVestingAccountInstruction = exports.CreateVestingTypeInstruction = void 0;
var schema_1 = require("@solvei/borsh/schema");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var Super = /** @class */ (function () {
    function Super() {
    }
    return Super;
}());
var CreateVestingTypeInstruction = /** @class */ (function (_super) {
    __extends(CreateVestingTypeInstruction, _super);
    function CreateVestingTypeInstruction(initial_unlock, start_time, end_time, unlock_period, cliff) {
        var _this = _super.call(this) || this;
        _this.initial_unlock = initial_unlock;
        _this.start_time = start_time;
        _this.end_time = end_time;
        _this.unlock_period = unlock_period;
        _this.cliff = cliff;
        return _this;
    }
    __decorate([
        (0, schema_1.field)(utils_1.FloatAsU64Creator)
    ], CreateVestingTypeInstruction.prototype, "initial_unlock", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], CreateVestingTypeInstruction.prototype, "start_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], CreateVestingTypeInstruction.prototype, "end_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], CreateVestingTypeInstruction.prototype, "unlock_period", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], CreateVestingTypeInstruction.prototype, "cliff", void 0);
    CreateVestingTypeInstruction = __decorate([
        (0, schema_1.variant)(0)
    ], CreateVestingTypeInstruction);
    return CreateVestingTypeInstruction;
}(Super));
exports.CreateVestingTypeInstruction = CreateVestingTypeInstruction;
var CreateVestingAccountInstruction = /** @class */ (function (_super) {
    __extends(CreateVestingAccountInstruction, _super);
    function CreateVestingAccountInstruction(amount) {
        var _this = _super.call(this) || this;
        _this.amount = amount;
        return _this;
    }
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], CreateVestingAccountInstruction.prototype, "amount", void 0);
    CreateVestingAccountInstruction = __decorate([
        (0, schema_1.variant)(1)
    ], CreateVestingAccountInstruction);
    return CreateVestingAccountInstruction;
}(Super));
exports.CreateVestingAccountInstruction = CreateVestingAccountInstruction;
var WithdrawFromVestingInstruction = /** @class */ (function (_super) {
    __extends(WithdrawFromVestingInstruction, _super);
    function WithdrawFromVestingInstruction(amount) {
        var _this = _super.call(this) || this;
        _this.amount = amount;
        return _this;
    }
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], WithdrawFromVestingInstruction.prototype, "amount", void 0);
    WithdrawFromVestingInstruction = __decorate([
        (0, schema_1.variant)(2)
    ], WithdrawFromVestingInstruction);
    return WithdrawFromVestingInstruction;
}(Super));
exports.WithdrawFromVestingInstruction = WithdrawFromVestingInstruction;
var WithdrawExcessiveFromPoolInstruction = /** @class */ (function (_super) {
    __extends(WithdrawExcessiveFromPoolInstruction, _super);
    function WithdrawExcessiveFromPoolInstruction(amount) {
        var _this = _super.call(this) || this;
        _this.amount = amount;
        return _this;
    }
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], WithdrawExcessiveFromPoolInstruction.prototype, "amount", void 0);
    WithdrawExcessiveFromPoolInstruction = __decorate([
        (0, schema_1.variant)(3)
    ], WithdrawExcessiveFromPoolInstruction);
    return WithdrawExcessiveFromPoolInstruction;
}(Super));
exports.WithdrawExcessiveFromPoolInstruction = WithdrawExcessiveFromPoolInstruction;
var ChangeVestingTypeScheduleInstruction = /** @class */ (function (_super) {
    __extends(ChangeVestingTypeScheduleInstruction, _super);
    function ChangeVestingTypeScheduleInstruction(initial_unlock, start_time, end_time, unlock_period, cliff) {
        var _this = _super.call(this) || this;
        _this.initial_unlock = initial_unlock;
        _this.start_time = start_time;
        _this.end_time = end_time;
        _this.unlock_period = unlock_period;
        _this.cliff = cliff;
        return _this;
    }
    __decorate([
        (0, schema_1.field)(utils_1.FloatAsU64Creator)
    ], ChangeVestingTypeScheduleInstruction.prototype, "initial_unlock", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], ChangeVestingTypeScheduleInstruction.prototype, "start_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], ChangeVestingTypeScheduleInstruction.prototype, "end_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], ChangeVestingTypeScheduleInstruction.prototype, "unlock_period", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], ChangeVestingTypeScheduleInstruction.prototype, "cliff", void 0);
    ChangeVestingTypeScheduleInstruction = __decorate([
        (0, schema_1.variant)(4)
    ], ChangeVestingTypeScheduleInstruction);
    return ChangeVestingTypeScheduleInstruction;
}(Super));
exports.ChangeVestingTypeScheduleInstruction = ChangeVestingTypeScheduleInstruction;
var CreateMultisigInstruction = /** @class */ (function (_super) {
    __extends(CreateMultisigInstruction, _super);
    function CreateMultisigInstruction(require_numbers, require_signers) {
        var _this = _super.call(this) || this;
        _this.require_numbers = require_numbers;
        _this.require_signers = require_signers;
        return _this;
    }
    __decorate([
        (0, schema_1.field)(["u8", constants_1.MULTISIG_OPERATIONS])
    ], CreateMultisigInstruction.prototype, "require_numbers", void 0);
    __decorate([
        (0, schema_1.field)([utils_1.PublicKeyCreator, constants_1.MAX_SIGNERS])
    ], CreateMultisigInstruction.prototype, "require_signers", void 0);
    CreateMultisigInstruction = __decorate([
        (0, schema_1.variant)(5)
    ], CreateMultisigInstruction);
    return CreateMultisigInstruction;
}(Super));
exports.CreateMultisigInstruction = CreateMultisigInstruction;
// Empty struct serialization issue
function serializeSignDevestingInstruction() {
    return new Uint8Array([6]);
}
exports.serializeSignDevestingInstruction = serializeSignDevestingInstruction;
// @variant(6)
// export class SignDevestingInstruction extends Super {
// }
var TransferMultisigInstruction = /** @class */ (function (_super) {
    __extends(TransferMultisigInstruction, _super);
    function TransferMultisigInstruction(amounts, accounts_to_transfers) {
        var _this = _super.call(this) || this;
        _this.amounts = amounts;
        _this.accounts_to_transfers = accounts_to_transfers;
        return _this;
    }
    __decorate([
        (0, schema_1.field)(["u64", constants_1.MAX_SIGNERS])
    ], TransferMultisigInstruction.prototype, "amounts", void 0);
    __decorate([
        (0, schema_1.field)([utils_1.PublicKeyCreator, constants_1.MAX_SIGNERS])
    ], TransferMultisigInstruction.prototype, "accounts_to_transfers", void 0);
    TransferMultisigInstruction = __decorate([
        (0, schema_1.variant)(7)
    ], TransferMultisigInstruction);
    return TransferMultisigInstruction;
}(Super));
exports.TransferMultisigInstruction = TransferMultisigInstruction;
var CreateConfigInstruction = /** @class */ (function (_super) {
    __extends(CreateConfigInstruction, _super);
    function CreateConfigInstruction(vesting_stop_enabled, vesting_stop_multisig_enabled, vesting_stop_multisig_withdraw_enabled) {
        var _this = _super.call(this) || this;
        _this.vesting_stop_enabled = vesting_stop_enabled;
        _this.vesting_stop_multisig_enabled = vesting_stop_multisig_enabled;
        _this.vesting_stop_multisig_withdraw_enabled =
            vesting_stop_multisig_withdraw_enabled;
        return _this;
    }
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], CreateConfigInstruction.prototype, "vesting_stop_enabled", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], CreateConfigInstruction.prototype, "vesting_stop_multisig_enabled", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], CreateConfigInstruction.prototype, "vesting_stop_multisig_withdraw_enabled", void 0);
    CreateConfigInstruction = __decorate([
        (0, schema_1.variant)(8)
    ], CreateConfigInstruction);
    return CreateConfigInstruction;
}(Super));
exports.CreateConfigInstruction = CreateConfigInstruction;
var ChangeAdministratorInstruction = /** @class */ (function (_super) {
    __extends(ChangeAdministratorInstruction, _super);
    function ChangeAdministratorInstruction(new_administrator) {
        var _this = _super.call(this) || this;
        _this.new_administrator = new_administrator;
        return _this;
    }
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], ChangeAdministratorInstruction.prototype, "new_administrator", void 0);
    ChangeAdministratorInstruction = __decorate([
        (0, schema_1.variant)(9)
    ], ChangeAdministratorInstruction);
    return ChangeAdministratorInstruction;
}(Super));
exports.ChangeAdministratorInstruction = ChangeAdministratorInstruction;
var Instruction = /** @class */ (function () {
    function Instruction(value) {
        this.enum = value;
    }
    __decorate([
        (0, schema_1.field)({ type: Super })
    ], Instruction.prototype, "enum", void 0);
    return Instruction;
}());
exports.Instruction = Instruction;
exports.schemas = (0, schema_1.generateSchemas)([
    CreateVestingTypeInstruction,
    CreateVestingAccountInstruction,
    WithdrawFromVestingInstruction,
    WithdrawExcessiveFromPoolInstruction,
    ChangeVestingTypeScheduleInstruction,
    CreateMultisigInstruction,
    TransferMultisigInstruction,
    CreateConfigInstruction,
    ChangeAdministratorInstruction,
    Instruction,
]);
//# sourceMappingURL=schema.js.map